var idCounter = 0;
function id() {
    return idCounter++;
}
export { id };
